export const TOP_TITLE_BAR_HEIGHT = '48px'
